import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { isNumber, toInteger, padNumber } from './math';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  // accepts manually typed dates in mm/dd/yyyy format
  // ensures the calendar picker highlights the entered date
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (
        dateParts.length === 3 &&
        isNumber(dateParts[0]) &&
        isNumber(dateParts[1]) &&
        isNumber(dateParts[2]) &&
        // force user to enter 4 digit year
        dateParts[2].length === 4
      ) {
        return {
          month: toInteger(dateParts[0]),
          day: toInteger(dateParts[1]),
          year: toInteger(dateParts[2])
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    // format  date picker selection from yyyy-mm-dd to mm/dd/yyyy
    return date
      ? `${isNumber(date.month) ? padNumber(date.month) : ''}/${isNumber(date.day) ? padNumber(date.day) : ''}/${date.year}`
      : '';
  }
}
